import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
// import { Tooltip } from '@mui/material';
// import { Fab } from '@material-ui/core';
// import AddIcon from '@mui/icons-material/Add';
import { Redirect } from 'react-router-dom';

const OrderTransferDetailsView = ({ reactTableData ,isRedirect,setRedirect,isTitle,setTitle}) => {
  const [rows] = useState(reactTableData.tableRowsData);
  const { t } = useTranslation('common');



  const tableConfig = {
    isEditable: false,
    isSortable: false,
    isResizable: false,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by Order No., Dlv Tracking No....',
  };

 
  
  if (isRedirect && isRedirect === "update") {
    return <Redirect to={`/merchant/pnd_order/order_add/1 `} />;
  } 
  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <Row>
            <Col md={12}>
              <h3 className="page-title">Assign Order Details</h3>
            </Col>
          </Row>
         
          <ReactTableBase
            name={t('instution_type.view.name_map')}
            key={'searchable'}
            columns={reactTableData.tableHeaderData}
            data={rows}
              tableConfig={tableConfig}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

OrderTransferDetailsView.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default OrderTransferDetailsView;
